import React, { useState, useEffect } from "react"
import axios from "axios"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"

const CalendarArchive = () => {
  document.title = "ATS - Calendar Archive";
  const [originalData, setOriginalData] = useState([])   // full data loaded
  const [filteredData, setFilteredData] = useState([])   // filtered result
  const [loading, setLoading] = useState(false)
  const [companyId, setCompanyId] = useState(null)

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    filters: {
      subject: "",
      created_by_name: "",
      event_type: "",
      candidate: "",
      job: "",
      status: "",
    },
  })

  const handleCompanyChange = company => {
    if (company?.company_id) {
      setCompanyId(company.company_id)
    }
  }

  // --------------------------
  // FETCH - Only one API call
  // --------------------------
  const fetchCalendars = async () => {
    setLoading(true)

    try {
      const res = await axios.get(
        `/api/v1/events/?archived_events=true&company_id=${companyId}`,
        {}
      )

      const results = res.data.results || []
      setOriginalData(results)
      setFilteredData(results) 
      console.log("results",results)
    } catch (error) {
      console.error("Error fetching archive:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (companyId) fetchCalendars()
  }, [companyId])

  // --------------------------
  // LOCAL FILTERING
  // --------------------------
  const applyFilters = () => {
    let filtered = [...originalData]

    Object.keys(lazyParams.filters).forEach(key => {
      const value = lazyParams.filters[key].toLowerCase()

      if (value) {
        filtered = filtered.filter(row => {
          let fieldValue = ""

          if (key === "candidate")
            fieldValue = row.candidate_ids?.[0]?.name || ""
          else if (key === "job")
            fieldValue = row.job_ids?.[0]?.name || ""
          else fieldValue = row[key] || ""

          return fieldValue.toLowerCase().includes(value)
        })
      }
    })

    setFilteredData(filtered)
  }

  useEffect(() => {
    applyFilters()
  }, [lazyParams.filters, originalData])

  // --------------------------
  // PAGINATION
  // --------------------------
  const onPage = event => {
    setLazyParams(prev => ({
      ...prev,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    }))
  }

  // --------------------------
  // FILTER INPUT TEMPLATE
  // --------------------------
  const filterFieldTemplate = (field, placeholder) => (
    <input
      type="text"
      className="p-inputtext p-component"
      placeholder={placeholder}
      onChange={e => {
        const value = e.target.value
        setLazyParams(prev => ({
          ...prev,
          filters: {
            ...prev.filters,
            [field]: value,
          },
          first: 0,
          page: 1,
        }))
      }}
    />
  )

  // --------------------------
  // ACTION COLUMN
  // --------------------------
  const actionTemplate = row => (
    <div className="d-flex gap-2">
      <i
        className="fa fa-edit text-primary"
        style={{ cursor: "pointer", fontSize: "1rem" }}
        onClick={() => console.log("Edit clicked", row)}
      ></i>

      <i
        className="fa fa-archive text-danger"
        style={{ cursor: "pointer", fontSize: "1rem" }}
        onClick={() => console.log("Archive clicked", row)}
      ></i>
    </div>
  )
const formatTime = (timeString) => {
  if (!timeString || typeof timeString !== "string") return "-";
  const parts = timeString.split(":");
  if (parts.length < 2) return "-";
  const [hours, minutes] = parts;
  if (isNaN(hours) || isNaN(minutes)) return "-";
  const date = new Date();
  date.setHours(Number(hours), Number(minutes), 0);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};
const formatInterviewDate = (dateString) => {
  if (!dateString) return "-";  

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const archiveReasonTemplate = (rowData) => {
  return (
    <div
      className="archive_template"
      title={rowData.reason_to_archive || "-"}
    >
      {rowData.reason_to_archive || "-"}
    </div>
  );
};
  return (
    <div className="container-fluid p-3">
      <h4 className="mb-3">Calendar Archive</h4>

      <div className="row mb-5">

      </div>
      <div className="row mb-3 mt-5">
        <div className="col-3">
          <h5 className="mb-0"  style={{color: "#0e527d"}}>Archived Interviews</h5>
        </div>


        <div className="col-9 d-flex justify-content-end align-items-center">
          <label className="me-2">Select Company</label>
          <div style={{ width: "170px" }}>
            <CompanySelector onCompanyChange={handleCompanyChange} />
          </div>
        </div>
      </div>
            {loading ? (
                <OrgTableShimmer columns={5} rows={7} titleWidth="210px" />
                ) : (
                <div className="card p-3 shadow-sm border-0">
                  <DataTable
                    value={filteredData.slice(
                      lazyParams.first,
                      lazyParams.first + lazyParams.rows
                    )}
                    paginator
                    loading={loading}
                    totalRecords={filteredData.length}
                    first={lazyParams.first}
                    rows={lazyParams.rows}
                    onPage={onPage}
                    // filterDisplay="row"
                    emptyMessage="No archived records found."
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 15, 20, 50]}
                    scrollable
                    scrollHeight="550px"
                    id="ArchiveReasonTableView"
                    tableStyle={{ minWidth: "60rem" }}
                  >
                    <Column
                      header="ID"
                      body={(rowData, { rowIndex }) =>
                        rowIndex + 1 + lazyParams.first
                      }
                      style={{ width: "5%" }}
                    />
                       <Column
                      field="job"
                      header="Job"
                      // filter
                      // filterElement={() => filterFieldTemplate("job", "Job")}
                      body={row => row.job_ids?.[0]?.name || "-"}
                    />

                    <Column
                      field="subject"
                      header="Subject"
                      // filter
                      // filterElement={() => filterFieldTemplate("subject", "Subject")}
                      body={row => row.subject || "-"}
                    />

                    <Column
                      field="created_by_name"
                      header="Created By"
                      // filter
                      // filterElement={() => filterFieldTemplate("created_by_name", "Created By")}
                    />

                    <Column
                      field="event_type"
                      header="Event Type"
                      // filter
                      // filterElement={() => filterFieldTemplate("event_type", "Event Type")}
                    />
                     <Column
                        header="Interview Date"
                        // filter 
                        // filterPlaceholder="Interview Date"
                        body={(rowData) => {
                          const slots = rowData.calendit_response?.results?.data || [];
                          return slots.length > 0 ? (
                            <div>
                              {slots.map((slot, index) => (
                                <div key={index}>
                                  {formatInterviewDate(slot.selected_date)}
                                </div>
                              ))}
                            </div>
                          ) : (
                            "-"
                          );
                        }}
                      />
                     <Column
                        header="Interview Time"
                        // filter
                        // filterPlaceholder="Interview Time"
                        body={(rowData) => {
                          const startTime = rowData.start_time ? formatTime(rowData.start_time) : "-";
                          const endTime = rowData.end_time ? formatTime(rowData.end_time) : "-";
                          return (
                            <div>
                              <div>{startTime}</div>
                              <div>{endTime}</div>
                            </div>
                          );
                        }}
                      />
                     

                     <Column
                        header="Meeting Link"
                        // // filter 
                        // filterPlaceholder="Meeting Link"
                        body={(rowData) => {
                          const slots = rowData.calendit_response?.results?.data || [];
                          return slots.length > 0 ? (
                            <div>
                              {slots.map((slot, index) => (
                                <div key={index}>
                                  {slot.meeting_link ? (
                                    <a
                                      href={slot.meeting_link}
                                      target="_blank"
                                      onClick={(e) => e.preventDefault()}   
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "gray",
                                        textDecoration: "line-through",
                                        cursor: "not-allowed"
                                      }}
                                      title="You cannot access the meeting link for past dates."
                                    >
                                      Link
                                    </a>
                                  ) : (
                                    "N/A"
                                  )}

                                </div>
                              ))}
                            </div>
                          ) : (
                            "N/A"
                          );
                        }}
                      />


                    <Column
                      field="candidate"
                      header="Candidate"
                      // filter
                      // filterElement={() => filterFieldTemplate("candidate", "Candidate")}
                      body={row => row.candidate_ids?.[0]?.name || "-"}
                    />
                    <Column
                      field="Archive Reason"
                      header="Archive Reason"
                      // filter 
                      // filterFieldTemplate
                      body={archiveReasonTemplate}
                    />

                 

                    <Column
                      field="status"
                      header="Status"
                      // filter
                      // filterElement={() => filterFieldTemplate("status", "Status")}/
                      body={row => row.status || "-"}
                    />
                    {/* <Column
                      field="Duration"
                      header="Duration"
                      sortable
                      filter
                      filterPlaceholder="Duration"
                      style={{ minWidth: "12rem" }}
                      body={(rowData) => rowData.duration}
                      className="d-none"
                    /> */}
                    {/* <Column
                      field="start_date"
                      header="Date"
                      // sortable
                      // filter
                      // filterField="start_date"     
                      // filterPlaceholder="Date"
                    /> */}

                    {/* <Column
                      field="start_time"
                      header="Time"
                      // sortable
                      // filter
                      // filterField="start_time"     
                      // filterPlaceholder="Time"
                    /> */}

                    {/* <Column
                      header="Action"
                      body={actionTemplate}
                      style={{ textAlign: "center", width: "10%" }}
                    /> */}
                  </DataTable>
                </div>
            )}

     
    </div>
  )
}

export default CalendarArchive
